<style scoped lang="scss" type="text/scss">
    .special-award-item-container {
        height: 14rem;
        background-color: #F4F4F4;
        color: #666;
        display: flex;
        flex-direction: column;

        .title-panel {
            height: 3rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 1rem;
            position: relative;
            color: #EEE;
            background-color: #333;
        }

        .award-targets-wrap {
            flex: 1;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            border-bottom-left-radius: .15rem;
            border-bottom-right-radius: .15rem;
            padding: 1rem;
            overflow: hidden;
            display: flex;
            align-items: center;

            .award-targets-content-wrap {
                width: 100%;
                max-height: 100%;
                overflow: auto;

                .award-targets {
                    width: 100%;
                    font-size: .85rem;

                    .award-target {
                        margin-top: .5rem;
                        line-height: 2.5rem;
                        height: 2.5rem;
                        text-align: center;
                        background-color: #FFF;
                        border-top: none;
                        border-bottom: none;
                        border-radius: .15rem;
                        overflow: hidden;

                        &:first-of-type {
                            margin-top: 0;
                        }

                        display: flex;

                        .left-block {
                            width: 3rem;
                            height: 2.5rem;
                            box-sizing: border-box;
                            background-color: #555;
                            color: #FFF;
                            font-size: 1.2rem;
                            display: flex;
                            justify-content: center;
                            align-items: center;
                        }

                        .text-content {
                            flex: 1;
                            box-sizing: border-box;
                            padding: 0 .5rem;
                            background-color: rgba(255, 255, 255, .1);
                            color: #555;
                        }
                    }
                }
            }
        }
    }
</style>

<template>
    <functional-card class="special-award-item-container"
                     @call-edit="callEdit" @call-remove="callRemove">
        <div class="title-panel" :title="info.name">
            <span class="global-text-ellipsis">{{ info.name }}</span>
        </div>
        <div class="award-targets-wrap">
            <div class="award-targets-content-wrap">
                <div class="award-targets" v-if="type === 'player'">
                    <div class="award-target"
                         v-for="(target, index) in info.special_player_awards"
                         :key="index"
                         :title="`${target.school_name}（ ${target.team_name} ）`"
                    >
                        <div class="left-block">
                            <i class="icon">&#xe686;</i>
                        </div>
                        <span class="text-content global-text-ellipsis">
                        {{ `${target.school_name}（ ${target.team_name} ）` }}
                    </span>
                    </div>
                </div>
                <div class="award-targets" v-if="type === 'player-member'">
                    <div class="award-target global-text-ellipsis" v-for="(target, index) in info.special_player_member_awards"
                         :key="index"
                         :title="`${target.personal_name}（ ${target.school_name} ）`"
                    >
                        <div class="left-block">
                            <i class="icon">&#xe686;</i>
                        </div>
                        <span class="text-content global-text-ellipsis">
                        {{ `${target.personal_name}（ ${target.school_name} ）` }}
                    </span>
                    </div>
                </div>
            </div>
        </div>
    </functional-card>
</template>

<script>
    import FunctionalCard from '../../../../../../components/functional-card/index';
    import RectangularText from '../../../../../../components/rectangular-text/index';

    export default {
        name: '',
        components: {
            RectangularText,
            FunctionalCard
        },
        props: {
            info: {
                type: Object,
                default: () => {
                    return {};
                }
            },
            type: String
        },
        data () {
            return {};
        },
        methods: {
            callEdit (callback) {
                this.$emit('call-edit', callback);
            },
            callRemove (callback) {
                this.$emit('call-remove', callback);
            }
        }
    };
</script>
